import * as React from 'react'

type SideVehicleSelectionContextType = {
  sideCheckedIds: string[]
  toggleSide: (id: string) => void
  toggleAllSide: (ids: string[], checked: boolean) => void
  clearSide: () => void
}

const SideVehicleSelectionContext =
  React.createContext<SideVehicleSelectionContextType | null>(null)

export const SideVehicleSelectionProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [sideCheckedIds, setSideCheckedIds] = React.useState<string[]>([])

  const toggleSide = React.useCallback((id: string) => {
    setSideCheckedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    )
  }, [])

  const toggleAllSide = React.useCallback((ids: string[], checked: boolean) => {
    setSideCheckedIds(checked ? ids : [])
  }, [])

  const clearSide = React.useCallback(() => setSideCheckedIds([]), [])

  return (
    <SideVehicleSelectionContext.Provider
      value={{ sideCheckedIds, toggleSide, toggleAllSide, clearSide }}
    >
      {children}
    </SideVehicleSelectionContext.Provider>
  )
}

export const useSideVehicleSelection = () => {
  const ctx = React.useContext(SideVehicleSelectionContext)
  if (!ctx)
    throw new Error(
      'useSideVehicleSelection must be used within SideVehicleSelectionProvider',
    )
  return ctx
}
